import { LabSample } from '../../contexts/LabSampleContext';

export interface LabMetrics {
    totalSamples: number;
    queuedSamples: number;
    criticalSamples: number;
    averageTurnaroundTime: number;
    samplesByStatus: Record<string, number>;
    samplesByType: Record<string, number>;
    testBacklog: number;
}

export const calculateLabMetrics = (samples: LabSample[]): LabMetrics => {
    const totalSamples = samples.length;
    const queuedSamples = samples.filter(s => s.status === 'queued').length;
    const criticalSamples = samples.filter(s => s.priority === 'critical').length;

    // Calculate average turnaround time (for completed samples)
    const completedSamples = samples.filter(s => s.status === 'complete' && s.completionDate);
    const averageTurnaroundTime = completedSamples.length > 0
        ? Math.round(completedSamples.reduce((sum, sample) => {
            const received = new Date(sample.receivedDate).getTime();
            const completed = new Date(sample.completionDate!).getTime();
            const days = (completed - received) / (1000 * 60 * 60 * 24);
            return sum + days;
        }, 0) / completedSamples.length)
        : 0;

    // Grouping helpers
    const samplesByStatus: Record<string, number> = {};
    const samplesByType: Record<string, number> = {};

    samples.forEach(sample => {
        samplesByStatus[sample.status] = (samplesByStatus[sample.status] || 0) + 1;
        samplesByType[sample.sampleType] = (samplesByType[sample.sampleType] || 0) + 1;
    });

    // Test backlog (queued + overdue)
    const now = new Date();
    const testBacklog = samples.filter(s =>
        s.status === 'queued' ||
        (s.testDueDate && new Date(s.testDueDate) < now && s.status !== 'complete')
    ).length;

    return {
        totalSamples,
        queuedSamples,
        criticalSamples,
        averageTurnaroundTime,
        samplesByStatus,
        samplesByType,
        testBacklog,
    };
};
